import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "row w-100" }
const _hoisted_2 = { class: "col-lg-6" }
const _hoisted_3 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "First Name")
], -1)
const _hoisted_5 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_6 = { class: "col-lg-6" }
const _hoisted_7 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Surname")
], -1)
const _hoisted_9 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_10 = { class: "col-lg-6" }
const _hoisted_11 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Date of Birth")
], -1)
const _hoisted_13 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_14 = { class: "col-lg-6" }
const _hoisted_15 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Email")
], -1)
const _hoisted_17 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_18 = { class: "col-lg-6" }
const _hoisted_19 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Mobile")
], -1)
const _hoisted_21 = {
  key: 0,
  class: "invalid-feedback"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _directive_mask = _resolveDirective("mask")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["justify-content-start align-items-start", { current: _ctx.isCurrent }]),
    "data-kt-stepper-element": "content"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.first_name) = $event)),
            type: "text",
            class: _normalizeClass(["form-control", { 'is-invalid': _ctx.v$.form.first_name.$errors.length }])
          }, null, 2), [
            [_vModelText, _ctx.form.first_name]
          ]),
          (_ctx.v$.form.first_name.$errors.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.v$.form.first_name.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.last_name) = $event)),
            type: "text",
            class: _normalizeClass(["form-control", { 'is-invalid': _ctx.v$.form.last_name.$errors.length }])
          }, null, 2), [
            [_vModelText, _ctx.form.last_name]
          ]),
          (_ctx.v$.form.last_name.$errors.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.v$.form.last_name.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(_component_el_date_picker, {
            type: "date",
            format: "DD/MM/YYYY",
            style: {"width":"100%"},
            modelValue: _ctx.form.date_of_birth,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.date_of_birth) = $event)),
            class: _normalizeClass({ 'is-invalid': _ctx.v$.form.date_of_birth.$errors.length })
          }, null, 8, ["modelValue", "class"]),
          (_ctx.v$.form.date_of_birth.$errors.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.v$.form.date_of_birth.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.email) = $event)),
            type: "text",
            class: _normalizeClass(["form-control", { 'is-invalid': _ctx.v$.form.email.$errors.length }])
          }, null, 2), [
            [_vModelText, _ctx.form.email]
          ]),
          (_ctx.v$.form.email.$errors.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.v$.form.email.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.mobile_number) = $event)),
            type: "text",
            class: _normalizeClass(["form-control", { 'is-invalid': _ctx.v$.form.mobile_number.$errors.length }])
          }, null, 2), [
            [_vModelText, _ctx.form.mobile_number],
            [_directive_mask, _ctx.maskingMobile]
          ]),
          (_ctx.v$.form.mobile_number.$errors.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.v$.form.mobile_number.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 2))
}